<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" href="#tabs-2-tab-1" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Grupos NCM
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" id="tabs-2-tab-1">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 40%">Código</th>
                                <th style="width: 40%">Descrição</th>
                                <th style="width: 10%">Status</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{ rowData.grupo_ncm.cd }}
                                </td>
                                <td>
                                    {{ rowData.grupo_ncm.descr }}
                                </td>
                                <td>
                                <span class="badge badge-success" v-if="rowData.grupo_ncm.status.valor==1">{{ rowData.grupo_ncm.status.descr }}</span>
                                <span class="badge badge-danger" v-if="rowData.grupo_ncm.status.valor==2">{{ rowData.grupo_ncm.status.descr }}</span>
                              </td>
                              <td>
                                  <a v-if="rowData.grupo_ncm.status.valor==2" @click="onActivateDesactivate(1, rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                  <a v-if="rowData.grupo_ncm.status.valor==1" @click="onActivateDesactivate(2, rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                  <a @click="onEditGrupo(rowData.grupo_ncm)" v-b-tooltip title="Editar Grupo"><i class="fa fa-edit"></i></a>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onEditGrupo(data) {
            Event.$emit('editGrupo', data);
        },
        onActivateDesactivate(action, data, tipo) {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.gruponcm_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.patch('/api/gruponcm/status').then(response =>
            {
                new ReturnApi(response, this);
                Event.$emit('reloadVuetable', data);
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
  }
}
  </script>
